// src/lib/format.ts
// Small input-formatting helpers used by the checkout form.

// formatPhone — live US phone formatting as the user types.
// Strips non-digits, drops a leading country "1", caps at 10 digits, and
// progressively formats to "(XXX) XXX-XXXX". Safe to call on every keystroke
// (idempotent: re-formatting an already-formatted value yields the same string).
export function formatPhone(input: string): string {
  let d = (input || '').replace(/\D/g, '');
  if (d.length === 11 && d.startsWith('1')) d = d.slice(1);
  d = d.slice(0, 10);
  const len = d.length;
  if (len === 0) return '';
  if (len < 4) return `(${d}`;
  if (len < 7) return `(${d.slice(0, 3)}) ${d.slice(3)}`;
  return `(${d.slice(0, 3)}) ${d.slice(3, 6)}-${d.slice(6)}`;
}

// phoneDigits — bare 10-digit string (no formatting) for validation/submit.
export function phoneDigits(input: string): string {
  let d = (input || '').replace(/\D/g, '');
  if (d.length === 11 && d.startsWith('1')) d = d.slice(1);
  return d.slice(0, 10);
}
